/**
 * If an error occurs while setting up a tactic, this message is sent to the FE
 * {
	"messageType": "alertNotification",
	"notificationId": 1645457521438,
	"notificationDetails": {"errorType":"SYSTEM_ERROR","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_CREATION_ERROR",
	"statusDetails": {"tacticName":"CANDLE_BREAK","errorMessage":"candle break null pointer"},
	"date": "2022-02-21T10:32:02.139-0500",
	"timestamp": "1645457522139"
}

 * @param {*} statusDetails 
 * @returns an object with fields:
 * 1) tacticName: the name of the tactic in which an exception occurred
 * 2) errorMessage: for example, there was a null pointer exception
 */
export function tacticCreationParser(statusDetails) {
  const parsedObj = {
    tacticName: null,
    errorMessage: null,
  };
  if (statusDetails) {
    parsedObj.tacticName = statusDetails.tacticName ?? null;
    parsedObj.errorMessage = statusDetails.errorMessage ?? null;
  }

  return parsedObj;
}
